"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var TraceEvent = /*#__PURE__*/function () {
  function TraceEvent(message) {
    (0, _classCallCheck2["default"])(this, TraceEvent);

    if (message) {
      this.setMessage(message);
    }
  }

  (0, _createClass2["default"])(TraceEvent, [{
    key: "setMessage",
    value: function setMessage(message) {
      this._message = this._checkAndFormatString("message", message, this.MESSAGE_MAX_LENGTH);
    }
  }, {
    key: "getMessage",
    value: function getMessage() {
      return this._message;
    }
  }, {
    key: "_logInvalidValue",
    value: function _logInvalidValue(expectedType, key, value) {
      console.warn("TraceEvent : la valeur ".concat(value, " du param\xE8tre ").concat(key, " est incorrecte/vide (type attendu : ").concat(expectedType, ")"));
    }
  }, {
    key: "_checkAndFormatString",
    value: function _checkAndFormatString(key, stringValue, maxLength) {
      if (typeof stringValue === "string" && stringValue.length > 0) {
        if (stringValue.length > maxLength) {
          console.warn("TraceEvent : la longueur du param\xE8tre ".concat(key, " est sup\xE9rieure \xE0 ").concat(maxLength, " caract\xE8res => tronqu\xE9e"));
          return stringValue.substring(0, maxLength);
        }

        return stringValue;
      } else {
        this._logInvalidValue("string", key, stringValue);

        return null;
      }
    }
  }, {
    key: "_addMetaData",
    value: function _addMetaData(type, key, value) {
      if (key) {
        this._metaDonnees = this._metaDonnees || {};
        this._metaDonnees[key] = {
          "type": type,
          "value": value
        };
      } else {
        console.warn("TraceEvent : le nom du param\xE8tre ".concat(key, " est incorrect/vide"));
      }

      return this;
    }
  }, {
    key: "addDate",
    value: function addDate(key, dateValue) {
      var convertDateToString = function convertDateToString(date) {
        var month = (date.getMonth() + 1 <= 9 ? "0" : "") + (date.getMonth() + 1);
        var day = (date.getDate() <= 9 ? "0" : "") + date.getDate();
        return "".concat(day, "/").concat(month, "/").concat(date.getFullYear());
      };

      if (dateValue instanceof Date) {
        dateValue = convertDateToString(dateValue);

        this._addMetaData(this._METADONNEES_TYPES.DATE, key, dateValue);
      } else {
        this._logInvalidValue("Date", key, dateValue);
      }

      return this;
    }
  }, {
    key: "addBoolean",
    value: function addBoolean(key, booleanValue) {
      if (typeof booleanValue === "boolean") {
        this._addMetaData(this._METADONNEES_TYPES.BOOLEAN, key, booleanValue);
      } else {
        this._logInvalidValue("boolean", key, booleanValue);
      }

      return this;
    }
  }, {
    key: "addString",
    value: function addString(key, stringValue) {
      stringValue = this._checkAndFormatString(key, stringValue, this.STRING_MAX_LENGTH);

      if (stringValue) {
        this._addMetaData(this._METADONNEES_TYPES.STRING, key, stringValue);
      }

      return this;
    }
  }, {
    key: "addFloat",
    value: function addFloat(key, floatValue) {
      if (typeof floatValue === "number" && !isNaN(floatValue) && floatValue !== Infinity) {
        var floatAsString = "".concat(floatValue); // Si écriture exposant ou longueur trop longue : on convertit

        if (floatAsString.includes("e") || floatAsString.length > this.FLOAT_MAX_LENGTH) {
          var roundedValue = Math.round(floatValue);

          if (roundedValue > Math.pow(10, this.FLOAT_MAX_LENGTH) - 1 || roundedValue < -Math.pow(10, this.FLOAT_MAX_LENGTH - 1)) {
            // Si valeur entière en écriture non exponentielle est supérieure à taille max => impossible de tronquer (ex: supérieur à 999999999999999 ou inférieur à -99999999999999 si la taille max FLOAT_MAX_LENGTH est 15)
            console.warn("TraceEvent : la longueur du param\xE8tre ".concat(key, " convertie en string est sup\xE9rieure \xE0 ").concat(this.FLOAT_MAX_LENGTH, " caract\xE8res (").concat(floatAsString, ") et ne peut pas \xEAtre tronqu\xE9e => ignor\xE9e"));
            return this;
          } else {
            // On réduit la précision au nombre de chiffres significatifs disponibles :
            // - taille max -2 pour le "-." si floatValue < -1
            // - taille max -3 pour le "-0." si -1 < floatValue < 0
            // - taille max -2 pour le "0." si 0 < floatValue < 1
            // - taille max -1 pour le "." si floatValue > 1
            var precision;

            if (floatValue < -1) {
              precision = this.FLOAT_MAX_LENGTH - 2;
            } else if (floatValue < 0) {
              precision = this.FLOAT_MAX_LENGTH - 3;
            } else if (floatValue < 1) {
              precision = this.FLOAT_MAX_LENGTH - 2;
            } else {
              precision = this.FLOAT_MAX_LENGTH - 1;
            }

            floatValue = Number(floatValue.toPrecision(precision)); // On convertit en chaîne de caractères avec écriture non exponentielle

            var convertedFloatAsString = floatValue.toFixed(this.FLOAT_MAX_LENGTH); // On tronque la chaîne obtenue à la taille max

            convertedFloatAsString = convertedFloatAsString.substring(0, this.FLOAT_MAX_LENGTH); // On logue si la chaîne de caractères obtenue est différente de l'initiale

            if (convertedFloatAsString !== floatAsString) {
              console.warn("TraceEvent : la valeur du param\xE8tre ".concat(key, " convertie en string est sup\xE9rieure \xE0 la taille max ").concat(this.FLOAT_MAX_LENGTH, " (").concat(floatAsString, ") => arrondi en ").concat(convertedFloatAsString));
              floatAsString = convertedFloatAsString;
            }
          }
        }

        this._addMetaData(this._METADONNEES_TYPES.FLOAT, key, floatAsString);
      } else {
        this._logInvalidValue("number (Float)", key, floatValue);
      }

      return this;
    }
  }, {
    key: "addDouble",
    value: function addDouble(key, doubleValue) {
      if (typeof doubleValue === "number" && doubleValue % 1 === 0) {
        if (doubleValue > Math.pow(10, this.FLOAT_MAX_LENGTH) - 1 || doubleValue < -Math.pow(10, this.FLOAT_MAX_LENGTH - 1)) {
          // Si valeur entière en écriture non exponentielle est supérieure à taille max => impossible de tronquer (ex: supérieur à 999999999999999 ou inférieur à -99999999999999 si la taille max FLOAT_MAX_LENGTH est 15)
          console.warn("TraceEvent : la longueur du param\xE8tre ".concat(key, " convertie en string est sup\xE9rieure \xE0 ").concat(this.DOUBLE_MAX_LENGTH, " caract\xE8res (").concat(doubleValue, ") et ne peut pas \xEAtre tronqu\xE9e => ignor\xE9e"));
          return this;
        }

        this._addMetaData(this._METADONNEES_TYPES.DOUBLE, key, doubleValue.toFixed());
      } else {
        this._logInvalidValue("number (Double)", key, doubleValue);
      }

      return this;
    }
  }, {
    key: "getAllMetaDataAsString",
    value: function getAllMetaDataAsString() {
      var str = [];

      for (var key in this._metaDonnees) {
        if (this._metaDonnees.hasOwnProperty(key)) {
          var metaDonnee = this._metaDonnees[key];
          str.push("[".concat(key, "=").concat(metaDonnee.value, "]"));
        }
      }

      return str.join(",");
    }
  }, {
    key: "getAllMetaDataAsRequestParametersString",
    value: function getAllMetaDataAsRequestParametersString() {
      var str = [];
      var paramValue;
      var paramName;

      for (var key in this._metaDonnees) {
        if (this._metaDonnees.hasOwnProperty(key)) {
          var metaDonnee = this._metaDonnees[key];
          paramName = metaDonnee.type.prefix + key;

          if (metaDonnee.type === this._METADONNEES_TYPES.BOOLEAN) {
            paramValue = metaDonnee.value ? 1 : 0;
          } else {
            paramValue = metaDonnee.value;
          }

          str.push("".concat(encodeURIComponent(paramName), "=").concat(encodeURIComponent(paramValue)));
        }
      }

      return str.join("&");
    }
  }]);
  return TraceEvent;
}();

TraceEvent.prototype._message = null;
TraceEvent.prototype._metaDonnees = null;
TraceEvent.prototype._METADONNEES_TYPES = {
  DATE: {
    prefix: "dt10_md_"
  },
  BOOLEAN: {
    prefix: "n10_b_md_"
  },
  STRING: {
    prefix: "f2000_md_"
  },
  DOUBLE: {
    prefix: "n15_md_"
  },
  FLOAT: {
    prefix: "n15_md_"
  }
};
TraceEvent.prototype.MESSAGE_MAX_LENGTH = 200;
TraceEvent.prototype.STRING_MAX_LENGTH = 2000;
TraceEvent.prototype.DOUBLE_MAX_LENGTH = 15;
TraceEvent.prototype.FLOAT_MAX_LENGTH = 15;
var _default = TraceEvent;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/awt-common-log/dist/TraceEvent.js
// module id = 135
// module chunks = 0